<template>
    <div class="div-buttons" v-if="filteredDataSource != null && filteredDataSource.length > 0">
        <DroppedDownMenu Id="actionsBtn" class="dm-internal-actions" :Header="header" :DataSource="filteredDataSource" v-on="filteredEvents" />
    </div>
</template>


<script>
    import DroppedDownMenu from "@supervision/vue-components/components/DropDownMenu"

    export default {

        name: "ActionsDroppedDown",

        components: {
            DroppedDownMenu
        },

        props: {
            header: {
                type: Object,
                required: true,
            },
            dataSource: {
                type: Array,
                required: true,
            },
            events: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                filteredDataSource: [],
                filteredEvents: {}
            };
        },
        created() {
            let controlledDataSource = [], controlledEvents = {};

            this.$props.dataSource.forEach(dataSource => {
                if(!this.$jwt.hasRole('dm-administrator') && dataSource.method == "returnToCommonStock")
                    return;
                controlledDataSource.push(dataSource);
            });

            this.$props.events.forEach(event => {
                for (const [key, value] of Object.entries(event)) {
                if(!this.$jwt.hasRole('dm-administrator') && key == "returnToCommonStock")
                    continue;
                controlledEvents[key] = value;
            }
            })
            

            this.filteredEvents = controlledEvents;
            this.filteredDataSource = controlledDataSource;
        },
    }
</script>

<style>

.ddm-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.dm-internal-actions > .ddm-content {
    min-width: 11rem!important;
}
.dm-internal-actions > .ddm-btn {
    min-width: 11rem!important;
}
</style>